var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6487 13.0885C17.9378 10.0355 16.7808 6.42903 13.8365 4.72919C11.7089 3.50082 9.18568 3.57848 7.19511 4.71344L6.36814 3.2661C8.85634 1.84743 12.0103 1.75036 14.6698 3.28581C18.4121 5.44638 19.8446 10.0711 18.1011 13.9271L19.2193 14.5727L15.7483 16.4178L15.6108 12.4894L16.6487 13.0885ZM4.35768 7.91684C3.06853 10.9699 4.22564 14.5764 7.16985 16.2762C9.29743 17.5045 11.8206 17.4269 13.8111 16.292L14.6381 17.7394C12.1499 19.1579 8.99601 19.255 6.33652 17.7196C2.59432 15.559 1.16181 10.9343 2.90528 7.07829L1.78711 6.43271L5.258 4.58763L5.39555 8.51605L4.35768 7.91684Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.4cf23e141c1ae81a79bcee46188d3ed7.svg";
export { ForwardRef as ReactComponent };